import React from 'react';

import { positions, Provider as AlertProvider, transitions } from 'react-alert';
import AlertTemplate from 'react-alert-template-basic';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import koLocale from 'date-fns/locale/ko';
import { MuiThemeProvider } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/styles';
import theme from '../../common/theme';

// optional cofiguration
const alertOptions = {
  // you can also just use 'bottom center'
  position: positions.BOTTOM_CENTER,
  timeout: 5000,
  offset: '1px',
  // you can also just use 'scale'
  transition: transitions.SCALE,
};

const LayoutWrapper = ({ children }) => (
  <AlertProvider template={AlertTemplate} {...alertOptions}>
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={koLocale}>
      <MuiThemeProvider theme={theme}>
        <ThemeProvider theme={theme}>
          <div className="App">
            {children}
          </div>
        </ThemeProvider>
      </MuiThemeProvider>
    </MuiPickersUtilsProvider>
  </AlertProvider>
);
export default LayoutWrapper;
